import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class FormDrawer {
  protected $closeButton: HTMLButtonElement;
  protected $drawer: HTMLElement;
  protected $toggle: HTMLElement;
  protected $form: HTMLFormElement | undefined;

  constructor($toggle: HTMLElement | null, $drawer: HTMLElement) {
    this.$drawer = $drawer;

    if ($toggle) {
      this.$toggle = $toggle;

      this.$toggle.addEventListener('click', (event) => this.onToggleClicked(event));
    }

    this.$closeButton = this.$drawer.querySelector('.tc-form-drawer__close');
    this.$form = this.$drawer.querySelector('form');

    this.$closeButton.addEventListener('click', (event) => this.onCloseButtonClicked(event));
  }

  public onToggleClicked(event?): void {
    if (event) {
      event.preventDefault();
    }

    disableBodyScroll();

    this.$drawer.style.display = 'block';

    setTimeout(() => {
      [].slice.call(this.$drawer.querySelectorAll('input[data-shadow-input]')).forEach(($input: HTMLInputElement) => {
        const $shadow = this.$drawer.querySelector(`input${$input.getAttribute('data-shadow-input')}`) as HTMLInputElement;

        $shadow.style.height = `${$input.clientHeight}px`;
        $shadow.style.width = `${$input.clientWidth}px`;
        $shadow.style.left = `${$input.offsetLeft}px`;
        $shadow.style.top = `${$input.offsetTop}px`;
      });
    }, 10);
  }

  protected onCloseButtonClicked(event): void {
    event.preventDefault();

    enableBodyScroll();

    this.$drawer.style.display = 'none';

    if (this.$form) {
      this.$form.classList.remove('was-validated');
      this.$form.reset();
    }
  }
}
